import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class SafetyService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getIncidentReport(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Incident/GetIncidentReport', data);
  }

  getIncidentType(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Incident/GETIncidentType', data);
  }

  getIncidentClassification(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Incident/GETIncidentClassification', data);
  }

  createIncidentReport(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Incident/SaveIncidentReport', data);
  }

  getBOSReport(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'BOS/GetBOSReport', data);
  }

  getBOSDescriptionType(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'BOS/GETBOSDescTypes', data);
  }

  createBOSReport(data:any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'BOS/SumbitBOSReportList', data);
  }
}
